import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@app/shared/services/auth.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-design-settings-menu',
  templateUrl: './design-settings-menu.component.html',
  styleUrls: ['./design-settings-menu.component.scss'],
})
export class DesignSettingsMenuComponent {
  constructor(
    public router: Router,
    public translate: TranslateService,
    public authService: AuthService,
  ) {}

  goTo(routes: string[]) {
    this.router.navigate(routes);
  }
}
